export enum ResponseStatuses {
  ok = "ok",
  error = "error",
}
